import { differenceInDays, differenceInWeeks, format } from "date-fns";

export const formatFriendlyDate = (date: Date) => {
  const now = new Date();
  const daysDiff = differenceInDays(now, date);

  if (daysDiff === 0) {
    return "Today";
  } else if (daysDiff < 7) {
    return `${daysDiff} day${daysDiff > 1 ? "s" : ""} ago`;
  } else if (daysDiff < 30) {
    const weeksDiff = differenceInWeeks(now, date);
    return `${weeksDiff} week${weeksDiff > 1 ? "s" : ""} ago`;
  } else {
    return format(date, "MMM d, yyyy");
  }
};
